// application wide constants can go here

export const rtlDir = 'rtl';
export const ltrDir = 'ltr';



// WEBPACK FOOTER //
// ./src/modules/app/constants.js